// extracted by mini-css-extract-plugin
export var imageContainer = "accreditationsTile-module--imageContainer--f2d9f";
export var tileContainer = "accreditationsTile-module--tileContainer--75a67";